import React from 'react'
import type { AnotherChildEnrollmentProps } from '@/features/enrollment'

export default function AnotherChildEnrollment({ enrollmentData, updateEnrollmentData, hourStats, onStartNextChild }: AnotherChildEnrollmentProps) {
  return (
    <div className="border border-accent-200 rounded-lg p-4 lg:p-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between mb-4 gap-4">
        <div>
          <h4 className="font-semibold text-accent-900">Enroll Another Child</h4>
          <p className="text-sm text-accent-600">Does the client want to submit for another child?</p>
        </div>
        <div className="flex space-x-3">
          <button
            className={`px-4 lg:px-6 py-2 rounded-lg font-medium transition-colors ${
              enrollmentData.submitAnotherChild
                ? 'bg-green-600 text-white'
                : 'bg-green-100 hover:bg-green-200 text-green-700'
            }`}
            onClick={() => updateEnrollmentData('submitAnotherChild', true)}
          >
            Yes
          </button>
          <button
            className={`px-4 lg:px-6 py-2 rounded-lg font-medium transition-colors ${
              enrollmentData.submitAnotherChild === false
                ? 'bg-red-600 text-white'
                : 'bg-red-100 hover:bg-red-200 text-red-700'
            }`}
            onClick={() => updateEnrollmentData('submitAnotherChild', false)}
          >
            No
          </button>
        </div>
      </div>
      {enrollmentData.submitAnotherChild && (
        <div className="bg-green-50 border border-green-200 rounded p-3 text-sm text-green-800">
          <div className="flex items-center justify-between gap-3 mb-2">
            <p>✅ Will copy ALL existing data (platforms, intake, gaming details, health info) and start new enrollment for another child</p>
            <button 
              className="btn-primary" 
              onClick={() => onStartNextChild && onStartNextChild()}
              disabled={hourStats.remainingGamers <= 0}
            >
              Start Now
            </button>
          </div>
          {hourStats.remainingGamers > 0 ? (
            <p className="text-green-700 font-medium">
              🎮 You have enough gaming hours for {hourStats.remainingGamers} more {hourStats.remainingGamers === 1 ? 'enrollment' : 'enrollments'} with this gamertag.
            </p>
          ) : (
            <p className="text-red-700 font-medium">
              ⚠️ No more enrollments possible with this gamertag. You need more gaming hours.
            </p>
          )}
        </div>
      )}
    </div>
  )
}
